import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const loanLibraryHistorySearchModel = (patronId = "", shippingLocationId = "", dueDate = "", searchTerm = "", loanLibraryLoanStatus: string | null = null, isOverdue: string | null = null, districtId = "", organization = "") => {
    return Object.assign({}, searchModel(patronId.toString(), "checkedOutDate", true, "checkedOutDate"), {
        patronId,
        shippingLocationId,
        dueDate,
        searchTerm,
        loanLibraryLoanStatus,
        isOverdue,
        districtId,
        organization,
        ClearLoanLibraryHistorySearch: clearLoanLibraryHistorySearch,
        ApplySorting: applySorting,
    });
};

function clearLoanLibraryHistorySearch(this: Record<string, unknown>) {
    this.patronId = "";
    this.shippingLocationId = "";
    this.dueDate = "";
    this.searchTerm = "";
    this.loanLibraryLoanStatus = null;
    this.isOverdue = null;
    this.districtId = "";
    this.organization = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(searchCriteria: Record<string, unknown>, items: Record<string, unknown>[]) {
    if (isNullOrUndefined(items) || isArrayNullOrEmpty(items))
        return items;

    return items.sort(dynamicSort(searchCriteria.sortByColumn as string, searchCriteria.sortDescending as boolean));
}
